import React from 'react'
import styled from 'styled-components'

const Title = styled.h2`
  padding: 32px 0px 32px 0px;
  color: ${props => props.theme.colors.gold};
`

const ProxyInstructions = ({ me }) => {
  return (
    <div>
      <Title>PGA Member Dues Billing Proxy</Title>
      <h4>Welcome, {me.displayName}</h4>
      <p>The PGA Member Dues Billing Proxy feature allows you to assign access to an individual (such as an employer, supervisor or agent) so that they may pay dues on your behalf.</p>
      <p>Please use the form below to register your proxy.</p>
      <p><b>All fields below are required.</b></p>
      <p>We will use this submitted information to create temporary access for your designated proxy.</p>
      <p>Once the proxy account is created, usage instructions will be sent by email.</p>
      <p>Proxy access expires 10 days after creation.</p>
    </div>
  )
}

export default ProxyInstructions
